import * as React from "react";
import { Col } from "./../Col";
import * as CMP from "../../../../components";

export class Silk extends React.Component<{ src?: string }, {}> {
    render() {
        return (
            <Col modifier="rj-racing-next-races__col--silk">
                <CMP.Silk src={this.props.src} />
            </Col>
        )
    }
}